import { getCache, setCache, removeCache } from '@/utils/session';
import { login, logout } from '@/api';
import { resetRouter } from '@/router';
const state = {
  accountInfo: getCache('USERINFO') || '',
  token: getCache('TOKEN') || '',
  warningNum: 0
};
const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USERINFO(state, userInfo) {
    state.accountInfo = userInfo;
  },
  SET_WARN(state, num) {
    state.warningNum = num;
  }
};
const actions = {
  login({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(res => {
        console.log('登录接口返回:', res);
        // 接口返回的数据结构是 {success: '1', msg: '登录成功', obj: {...}}
        if (res && res.obj) {
          console.log('设置用户信息:', res.obj);
          commit('SET_TOKEN', res.obj.token);
          setCache('TOKEN', res.obj.token);
          commit('SET_USERINFO', res.obj);
          setCache('USERINFO', res.obj);
        }
        resolve();
      }).catch(err => {
        console.error('登录接口错误:', err);
        reject(err);
      });
    });
  },
  codeTest({
    commit
  }, userInfo) {
    // return new Promise((resolve, reject) => {
    //   getCodeTest(userInfo)
    //     .then(res => {
    //       const { data } = res;
    //       if (data) {
    //         commit('SET_TOKEN', data.token);
    //         setCache('TOKEN', data.token);
    //       }
    //       resolve();
    //     })
    //     .catch(err => {
    //       reject(err);
    //     });
    // });
  },
  feactWarning({
    commit
  }) {
    // queryExponent({
    //   pageNumber: 1,
    //   pageSize: 1,
    //   readed: 0
    // }).then(res => {
    //   commit('SET_WARN', res.page.totalCount);
    // });
  },
  logout({
    commit,
    state
  }, timeout = false) {
    if (timeout) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '');
        commit('SET_USERINFO', '');
        commit('permission/RESET_ROUTE', [], {
          root: true
        });
        removeCache('TOKEN');
        removeCache('USERINFO');
        resetRouter();
        resolve();
      });
    }
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '');
      commit('SET_USERINFO', '');
      commit('permission/RESET_ROUTE', [], {
        root: true
      });
      removeCache('TOKEN');
      removeCache('USERINFO');
      resetRouter();
      resolve();
    });
  },
  updateInfo({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      commit('SET_USERINFO', userInfo);
      setCache('USERINFO', userInfo);
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};